<template>
  <el-dialog :visible="show" top="5vh" width="1240px" :title="dlg_title" class="e-fence-dlg" destroy-on-close
    :close-on-click-modal="false" @open="fn_dlg_open" @opened="fn_dlg_opened" @closed="fn_dlg_closed"
    @close="fn_dlg_close">
    <div class="e-fence-dlg-content">
      <div class="e-fence-dlg-content-top">
        <el-form :model="fence" ref="formRef" inline :rules="formRules" :disabled="is_marking">
          <el-form-item prop="name" label="围栏名称">
            <el-input style="width:120px;" v-model="fence.name" placeholder="输入围栏名称" />
          </el-form-item>
          <el-form-item prop="shape" label="围栏形状">
            <el-radio-group v-model="fence.shape" @change="fn_shape_change" :disabled="fence_is_edit">
              <el-radio :label="enum_shape.circle">圆形</el-radio>
              <el-radio :label="enum_shape.polygon">多边形</el-radio>
            </el-radio-group>
          </el-form-item>
         
        </el-form>
        <div class="button-wrap">
          <el-button :disabled="btn_disabled || is_marking" size="small" type="primary"
            @click="fn_btn_save">保存</el-button>
          <el-button :disabled="btn_disabled || is_marking" size="small" type="default" @click="fn_draw_polygon">
            {{ btn_txt }}
          </el-button>

        </div>

      </div>
      <div class="e-fence-dlg-content-map-wrapper">
        <div ref="map" id="map"></div>
        <div class="tips">
          <span>{{ pos }}</span>
          <span v-html="tips"></span>
        </div>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import { mapGetters } from 'vuex'


const enum_shape = {
  circle: 'CIRCLE',
  polygon: 'POLYGON'
}

// 设置安全密钥  
window._AMapSecurityConfig = {
  // serviceHost:'您的代理服务器域名或地址/_AMapService',  
  securityJsCode: '78359427ec75b294d1085b283c76a9d7'
}
const key = 'e1e067886b395ac1aa709c2dd9982e7a'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      // shape_is_editing: false,
      fencedEntrance: '',//围栏入口位置
      is_marking: false, //标记入口操作
      fence_is_edit: false,
      formRules: {
        name: {
          required: true,
          message: '输入围栏名称'
        },
        shape: {
          required: true,
          message: '围栏形状'
        }
      },
      dlg_title: '增加围栏',
      btn_disabled: false,
      btn_txt: '开始',
      pos: '',
      tips: '',
      fence: {
        name: '',
        // fun: [],
        points: [],
        fenceMaxCars: '',
        state: true,
        shape: 'POLYGON',//围栏形状  CIRCLE   POLYGON
        fenceType: '0'
      }
    }
  },
  computed: {
    ...mapGetters(['usergt']),
    enum_shape() {
      return enum_shape
    }
  },
  // mounted() {
  //   console.log(this.usergt);
  // },
  watch: {
    fencedEntrance(val) {
      console.log('val==>>', val);
      if (!val) {
        return
      }
      this.add_entrance_marker()
    },
    info(val) {
      if (val) {
        console.log(val);
        this.fence_is_edit = true
        this.dlg_title = '修改围栏'
        const { fenceMaxCars, electronicFenceName, shape, electronicFenceFunction, longitudeLatitude, fenceType = '0'} = val
        this.fence.name = electronicFenceName;
        this.fence.fenceType = fenceType;
        // this.fence.fun = electronicFenceFunction.split(',');
        this.fence.shape = shape || enum_shape.polygon
        this.fencedEntrance = val.fencedEntrance

        this.fence.fenceMaxCars = fenceMaxCars
        if (longitudeLatitude) {
          if (this.fence.shape == enum_shape.circle) {
            this.fence.points = longitudeLatitude.split(';')
          } else if (this.fence.shape == enum_shape.polygon) {
            this.fence.points = longitudeLatitude.split(';').map(it => it.split(','))
          } else { }


        } else {
          this.fence.points = []
          this.polygon = null;
          this.circle = null
        }
      } else {
        this.fence_is_edit = false;
        this.fence.points = []
        this.fence.name = ''
        this.fence.fn = []
        this.fence.state = true
        this.fence.fenceType='0'
        this.$cb = null
        this.polygon = null;
        this.dlg_title = '增加围栏'
      }
    },
    "fence.shape": {
      immediate: false,
      handler(val) {
        if (this.editor) {
          this.$close_editor()
        }
        if (this.circle) {
          this.map.remove(this.circle)
        }
        if (this.polygon) {
          this.map.remove(this.polygon)
        }
        // this.fence.points = []
      }
    },
    "fence.points": {
      immediate: true,
      handler(path) {
        if (path.length > 2) {
          function cb() {
            if (this.fence.shape == enum_shape.polygon) {
              if (this.polygon) {
                this.map.remove(this.polygon)
              }
              this.polygon = new this.AMap.Polygon({ path, draggable: false, bubble: true })
              this.map.add(this.polygon)
            }
            if (this.fence.shape == enum_shape.circle) {
              if (this.circle) {
                this.map.remove(this.circle)
              }
              this.circle = new this.AMap.Circle({ center: path.slice(0, 2), radius: path[2], bubble: true })
              this.map.add(this.circle)
            }
            this.map.setFitView()
            this.tips = '点击 <kbd>编辑</kbd> 开始编辑图形'
            this.btn_txt = '编辑'
          }
          if (this.AMap && this.map) {
            cb.call(this)
          }
          this.$cb = cb.bind(this)
        } else {
          if (this.polygon && this.map) {
            this.map.remove(this.polygon)
            this.polygon = null
          }
          if (this.circle && this.map) {
            this.map.remove(this.circle)
            this.circle = null
          }
          this.tips = '点击 <kbd>开始</kbd> 开始绘图'
          this.btn_txt = '开始'
          this.btn_disabled = false
        }
      }
    }
  },
  methods: {
    add_entrance_marker() {
      if (!this.AMap) {
        this.$once('map-ready', this.add_entrance_marker)
        return
      }
      if (this.entrance_marker) {
        this.map.remove(this.entrance_marker)
      }
      this.entrance_marker = new this.AMap.Marker({
        position: this.fencedEntrance.split(','),
        offset: new AMap.Pixel(-10, -10),
        title: '围栏入口',
        icon: '//vdata.amap.com/icons/b18/1/2.png', // 添加 Icon 图标 URL
      })
      this.map.add(this.entrance_marker)
    },
    //标记围栏入口
    // fn_marker_fence_entrance() {
    //   this.is_marking = true;
    //   this.map.on('click', this.fn_map_click)
    // },
    // fn_map_click(e) {
    //   this.is_marking = false
    //   this.fencedEntrance = e.lnglat.toString()
    //   this.map.off('click', this.fn_map_click)

    // },
    fn_shape_change() {
      this.fence.points = []
      this.$close_editor()
      if (this.map) {
        this.circle && this.map.remove(this.circle)
        this.polygon && this.map.remove(this.polygon)
      }
    },
    //点击保存按钮
    async fn_btn_save() {
      try {

        if (this.editor) {
          this.$close_editor()
        }
        await this.$refs.formRef.validate()

        const { name, fun, shape, points, fenceMaxCars, fenceType } = this.fence
        if (points.length == 0) {
          this.$message.error('没有绘制电子围栏')
          throw '没有绘制电子围栏'
        } 
        // if (!this.fencedEntrance) {
        //   if (fenceType == '0') {
        //     this.$message.error('未选择围栏入口')
        //     throw '未标记围栏入口'
        //   }
        // }
        const data = {
          electronicFenceName: name,
          longitudeLatitude: shape == enum_shape.polygon ? points.map(it => `${it[0]},${it[1]}`).join(';') : points.join(';'),
          status: 0, shape,
          peopleCreate: this.usergt.username,
          fenceMaxCars,
          fenceType
        }
        console.log(data);
        let url;
        if (this.info&&this.info.id) {
          url = "/electronicfence/fence/update"
          data.id = this.info.id
        } else {
          url = '/electronicfence/fence/save'
        }
        const res = await this.$http(
          'api1',
          url,
          'post',
          data,
        )
        console.log("res", res)
        if (res.data.code != 0) {
          this.$message.error(res.data.msg)
          throw res
        }
        this.$message.success('操作成功')
        this.$emit('success')
        this.$emit('close')
      } catch (error) {
        console.log("error", error)
      }
    },
    fn_dlg_open() {
      if (this.$ref) {
        this.$refs.formRef.clearValidate()
      }
    },
    fn_dlg_opened() {
      this.$refs.formRef.clearValidate()
      this.init_map()
    },
    fn_dlg_close() {
      if (this.$ref) {
        this.$refs.formRef.clearValidate()
      }
      this.$emit('close')
    },
    fn_dlg_closed() {
      this.AMap = null
      this.map = null
      this.fencedEntrance = ''
      this.fence.name = '';
      // this.fence.fun = [];
      this.fence.points = [];
      this.fence.enable = true
      this.fence.fenceMaxCars = '';
      this.fence.shape = enum_shape.polygon;
      this.load_ins = null;
      if (this.mouse_tool) {
        this.mouse_tool.close(true);
        this.mouse_tool = null;
      }
      if (this.editor) {
        this.editor.close()
        this.editor = null
      }
      if (this.polygon) {
        if (this.map) {
          this.map.remove(this.polygon)
          this.map.clearMap()
        }
        this.polygon = null
      }
      this.$cb = null
    },
    async init_map() {
      this.btn_disabled = false
      this.load_ins = this.$loading.service({
        target: this.$el,
        lock: true,
        text: '数据请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const AMap = await AMapLoader.load({
        key,
        version: '2.0',
        plugins: ['AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.MouseTool']
      });
      this.AMap = AMap
      const map = new AMap.Map(this.$refs.map, {
        viewMode: '2D',
        // center: [117.801029, 38.961255],
        center: [117.738375, 38.972044],
        // center: [122.21433548, 30.26277236],
        zoom: 14,
        resize: true,
      })

      //实时路况图层
      // var trafficLayer = new AMap.TileLayer.Traffic({
      //   zIndex: 10,
      //   zooms: [7, 22],
      // }); 
      // trafficLayer.setMap(map);


      map.on('mousemove', e => {
        this.pos = `POS:${e.lnglat.toString()}`
      })
      // map.on('complete', e => {
      //   if (this.$cb) {
      //     this.$cb()
      //     this.$cb = null
      //   }

      // })

      this.map = map
      this.load_ins.close()
      this.$cb && this.$cb()

      this.$emit('map-ready')

    },
    $close_editor() {
      switch (this.fence.shape) {
        case enum_shape.polygon: {
          if (!this.polygon) {
            return
          }
          const path = this.polygon.getPath()
          this.fence.points = path.map(it => [it.lng, it.lat])
          this.editor.close()
          this.editor = null
          break;
        }
        case enum_shape.circle: {
          if (!this.circle) {
            return
          }
          const center = this.circle.getCenter()
          const radius = this.circle.getRadius()
          // if (radius > 100) {//小于100米 丢掉
          this.fence.points = [center.lng, center.lat, radius];
          this.editor.close()
          this.editor = null
          // } else {
          //   this.$message.error('围栏半径过小,重新编辑')
          //   this.map && this.map.remove(this.circle)
          //   this.editor.close()
          //   this.editor = null
          //   this.circle = null
          //   // this.fence
          // }
          break
        }
        default: { }
      }
      // this.shape_is_editing = false


    },
    fn_draw_polygon() {
      if (this.editor) {
        this.$close_editor()
        return
      }
      // this.shape_is_editing = true
      if (!this.mouse_tool) {
        this.mouse_tool = new AMap.MouseTool(this.map)
        AMap.Event.addListener(this.mouse_tool, 'draw', e => {
          if (this.fence.shape == enum_shape.circle) {
            const center = e.obj.getCenter()
            const radius = e.obj.getRadius()
            // if (radius > 100) {
            this.fence.points = [center.lng, center.lat, radius];
            this.mouse_tool.close(true)
            this.btn_disabled = false
            // } else {//小于100米 丢掉
            //   this.$message.error('围栏半径过小,请重新绘制')
            //   this.mouse_tool.close(true)
            //   this.fence.points = []

            // }

          } else if (this.fence.shape == enum_shape.polygon) {
            const path = e.obj.getPath()
            if (path&&path.length > 2) {
              this.fence.points = path.map(it => [it.lng, it.lat])
            }
            this.mouse_tool.close(true)
            this.btn_disabled = false
          } else { }
          // this.shape_is_editing = false


        });
      }
      if (this.fence.shape == enum_shape.polygon) {//画多边形 
        if (this.polygon) {
          const editor = new this.AMap.PolyEditor(this.map, this.polygon)
          this.editor = editor
          editor.open()
          this.btn_disabled = false
          this.btn_txt = '结束编辑'
          this.tips = '拖拽图形上的点 编辑图形'
        } else {
          this.mouse_tool.close(true)
          this.mouse_tool.polygon({ strokeColor: 'blue' })
          this.btn_disabled = true
          this.btn_txt = '正在绘图'
          this.tips = '依次点击地图,绘制图形'
        }
      } else if (this.fence.shape == enum_shape.circle) {//画圆形
        if (this.circle) {
          this.editor = new this.AMap.CircleEditor(this.map, this.circle)
          this.editor.open()
          this.btn_disabled = false
          this.btn_txt = '结束编辑'
          this.tips = '拖拽图形上的点 编辑图形'
        } else {
          this.mouse_tool.close(true)
          this.mouse_tool.circle({ strokeColor: 'blue' })
          this.btn_disabled = true
          this.btn_txt = '正在绘图'
          this.tips = '在地图上按下鼠标左键并拖动,绘制圆形'
        }

      } else { }


    }
  }

}
</script>

<style lang="scss"  >
.e-fence-dlg {
  display: flex;
  flex-direction: column;

  .e-fence-dlg-content-top {
    height: 55px;
    box-sizing: border-box;
  }

  .el-form-item__error {
    top: 32px;
  }

  label {

    &.el-checkbox,
    &.el-radio {
      margin-right: 10px;
    }
  }

  kbd {
    margin: 0 .2em;
    padding: .15em .4em .1em;
    font-size: 90%;
    background: rgba(150, 150, 150, .06);
    border: 1px solid rgba(100, 100, 100, .2);
    border-bottom-width: 2px;
    border-radius: 3px;
  }

  .el-form--inline .el-form-item {
    margin-right: 20px;
  }

  .el-dialog__body {
    padding: 0 20px;
    height: calc(90vh - 55px);
  }

  &-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 30px;

    // @note css-top
    &-top {
      // height: 60px;
      // padding: 8px 20px 0;
      display: flex;
      justify-content: space-between;
      padding-bottom: 10px;

      .button-wrap {
        display: flex;
        align-items: center;
      }
    }

    &-map-wrapper {
      flex: 1;
      position: relative;

      .tips {
        color: #3E2723;
        position: absolute;
        width: 100%;
        height: 30px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;

        .fence-entrance {
          position: absolute;
          left: 200px;
        }
      }

      #map {
        width: 100%;
        height: 100%;
      }
    }

  }

}
</style>